import {ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'preview-page',
    templateUrl: './preview-page.component.html',
    styleUrls: [
        './preview-page.component.scss',
        '../../../components/notifications/notification-banner/notification-banner.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class PreviewPageComponent implements OnInit {
    content: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        const content = this.route.snapshot.queryParams.content;

        if (content) {
            this.content = atob(content);
        }
    }
}
